var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "M9.728 2.01a2.1 2.1 0 0 1 2.97 0l1.414 1.414a2.1 2.1 0 0 1 0 2.97l-7.328 7.327a2.1 2.1 0 0 1-1.257.603l-2.412.262c-.91.1-1.68-.67-1.58-1.58l.262-2.41c.052-.476.265-.92.604-1.258zm2.12.848a.9.9 0 0 0-1.272 0l-7.328 7.328a.9.9 0 0 0-.258.54l-.262 2.41a.234.234 0 0 0 .257.258l2.412-.262a.9.9 0 0 0 .539-.26l7.327-7.326a.9.9 0 0 0 0-1.274z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "M9.728 2.01a2.1 2.1 0 0 1 2.97 0l1.414 1.414a2.1 2.1 0 0 1 0 2.97L12.556 7.95l-.07.07-.071-.07-4.242-4.243-.072-.07zm2.121.848a.9.9 0 0 0-1.273 0l-.777.777 2.686 2.688.778-.777a.9.9 0 0 0 0-1.274z"
  })));
};
export default SvgEdit;